import React, { useEffect } from 'react'
import PhoneIcon from '../../../assets/icons/PhoneIcon'
import InstagramIcon from '../../../assets/icons/InstagramIcon'
import YoutubeIcon from '../../../assets/icons/YoutubeIcon'
import WhatsappIcon from '../../../assets/icons/WhatsappIcon'
import { Link } from 'react-router-dom'
import logo from "../../../assets/images/logo.png";
import { useDispatch, useSelector } from 'react-redux'
import { getProductsFooter } from '../../../services/actions/MainAction'
function Footer() {
  const contentData = useSelector(state => state.Data.contentData);
  const contactData = useSelector(state => state.Data.contactData)
  const lang_id = useSelector(state => state.Data.lang_id)
  const productsDataFooter = useSelector(state => state.Data.productsDataFooter);
  const navServices = useSelector(state => state.Data.navServices);
  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(getProductsFooter(lang_id))
  },[lang_id])
  return (
    <footer className=' overflow-hidden relative border-t'>
      {/* <div className='h-auto bg-white pt-[1px]'>
          <div className='container'>
            <div className='flex items-center mt-[0px] justify-between gap-[100px] max-[1000px]:gap-[60px] max-[800px]:flex-col max-[800px]:gap-[00px] pb-[20px]'>
            <Link onClick={()=>window.scrollTo(0,0)} className="" to="/">
              <img src={logo} alt="logo" className="w-[300px] " />
            </Link>
              <div className='flex flex-col justify-between items-end'>
                <div className='grid grid-cols-4 mt-[30px] gap-[100px] max-[1000px]:gap-[60px] max-[800px]:grid-cols-3 max-[550px]:gap-[20px] max-[550px]:grid-cols-2 max-[450px]:grid-cols-1'>
                  <div>
                    <h3 className='text-[#222] text-[28px] max-[1000px]:text-[22px] hover:text-[--red]'>{contentData?.nav_2}</h3>
                      <ul className='flex flex-col gap-[13px] mt-[10px]'>
                        {
                          navServices?.map((data, i) =>{
                            if(i < 3){
                              return(
                                <li key={i} className='text-[#222] ml-[6px] hover:text-[--red]'>
                                  <Link to={`/product/${data?.path}`}>{data?.translate?.title}</Link>
                                </li>
                              )
                            }
                           
                          })
                        }
                      </ul>
                  </div>
                  <div>
                    <h3 className='text-[#222] text-[28px] max-[1000px]:text-[22px] hover:text-[--red]'>{contentData?.nav_3}</h3>
                      <ul className='flex flex-col gap-[13px] mt-[10px]'>
                        {
                          productsDataFooter?.map((data, i) =>{
                            if(i < 3){
                              return(
                                <li key={i} className='text-[#222] ml-[6px] hover:text-[--red]'>
                                  <Link to={`/product/${data?.path}`}>{data?.translate?.title}</Link>
                                </li>
                              )
                            }
                           
                          })
                        }
                      </ul>
                  </div>
                  <div>
                    <h3 className='text-[#222] text-[28px] max-[1000px]:text-[22px] hover:text-[--red]'>{contentData?.nav_4}</h3>
                      <ul className='flex flex-col gap-[13px] mt-[10px]'>
                      <li className='text-[#222] ml-[6px] hover:text-[--red]'>
                        <Link to={'/awards'}>{contentData?.nav_6}</Link>
                      </li>
                      <li className='text-[#222] ml-[6px] hover:text-[--red]'>
                        <Link to={'/license'}>{contentData?.nav_7}</Link>
                      </li>
                    
                    
                    </ul>
                  </div>
                  <ul className="flex items-end h-full mt-[0px]">
                  <li className="w-[45px] h-[50px]  flex justify-center items-center">
                    <a href={`tel:${contactData?.phone_1}`} className="inline-flex w-full h-full justify-center items-center">
                      <PhoneIcon color="#222" />
                    </a>
                  </li>
                  <li className="w-[45px] h-[50px]  flex justify-center items-center">
                    <a target='_blank' href={contactData?.instagram} className="inline-flex w-full h-full justify-center items-center">
                      <InstagramIcon color="#222"  />
                    </a>
                  </li>
                  <li className="w-[45px] h-[50px]  flex justify-center items-center">
                    <a target='_blank' href={contactData?.youtube} className="inline-flex w-full h-full justify-center items-center">
                      <YoutubeIcon color="#222"  />
                    </a>
                  </li>
                  <li className="w-[45px] h-[50px]  flex justify-center items-center">
                    <a target='_blank' href={`https://wa.me/${contactData?.whatsapp_1?.replaceAll(" ","")?.replace("+","")}`} className="inline-flex w-full h-full justify-center items-center">
                      <WhatsappIcon color="#222" />
                    </a>
                  </li>
                </ul>
                </div>
               
              </div>
             
            </div>
            
          </div>
        </div> */}
        <div  className='bg-black  h-[50px] flex items-center'>
          <div className='container2'>
            <p className='text-[#fff] text-[14px] max-[550px]:text-[10px] text-center'>All Copyright Reserved © 2025 | Developed By Zakir Abdurrahimov</p>
          </div>
        </div>
    </footer>
  )
}

export default Footer